import { defineComponent as o, openBlock as n, createBlock as l, unref as a, mergeProps as i, withCtx as c, createElementVNode as p } from "vue";
import { RevIcon as m } from "@ds/components/Icon";
const u = /* @__PURE__ */ o({
  name: "IconArrowRightInCircleFilled",
  __name: "IconArrowRightInCircleFilled",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(r) {
    const t = r;
    return (s, e) => (n(), l(a(m), i(t, { "view-box": "0 0 24 24" }), {
      default: c(() => [...e[0] || (e[0] = [
        p("path", { d: "M18.894 18.894c-3.807 3.808-9.98 3.808-13.788 0s-3.808-9.98 0-13.788 9.98-3.808 13.788 0 3.808 9.98 0 13.788m-1.96-6.01a1.25 1.25 0 0 0 0-1.768l-3.232-3.232a.75.75 0 0 0-1.06 1.06l2.305 2.306h-7.19a.75.75 0 1 0 0 1.5h7.19l-2.305 2.306a.75.75 0 0 0 1.06 1.06l3.233-3.232" }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  u as default
};
